export default __webpack_public_path__ + "static/media/firebase-dark.98a2ae54.png";